// Chat round five (M63, docs/chat-round-five.md): shared rules for a
// person's own chat settings, used by the server at push time and by the
// apps for sounds and icons.
/**
 * Whether a chat is muted now (D233): in the muted list, and either with no
 * end time (Always, including every mute from before M63) or one that
 * hasn't passed.
 */
export function isChatMuted(prefs, conversationId, now = Date.now()) {
    if (!prefs?.mutedConversationIds?.includes(conversationId))
        return false;
    const until = prefs.mutedConversationUntil?.[conversationId];
    if (!until)
        return true;
    const end = Date.parse(until);
    return Number.isNaN(end) || end > now;
}
/** When a chat's mute ends, or null for Always or not muted. */
export function muteEndsAt(prefs, conversationId, now = Date.now()) {
    if (!isChatMuted(prefs, conversationId, now))
        return null;
    return prefs?.mutedConversationUntil?.[conversationId] ?? null;
}
/**
 * The muted list and end times with ended mutes taken out, and end times
 * kept only for chats still in the list (D233).
 */
export function liveMutes(prefs, now = Date.now()) {
    const ids = (prefs.mutedConversationIds ?? []).filter((id) => isChatMuted(prefs, id, now));
    const until = {};
    for (const id of ids) {
        const end = prefs.mutedConversationUntil?.[id];
        if (end)
            until[id] = end;
    }
    return { mutedConversationIds: ids, mutedConversationUntil: until };
}
//# sourceMappingURL=chatSettings.js.map